import React from 'react';
import PropTypes from 'prop-types';
import {Field, useField} from 'formik';
import {Flex, FormControl, FormErrorMessage, FormLabel, HStack, Input, InputGroup} from '@chakra-ui/react';

export const InputLabelField = ({
                                  name,
                                  label,
                                  maxLength = undefined,
                                  isReadOnly = false
                                }) => {
  const [, meta] = useField(name);
  const hasError = meta.touched && meta.error;

  return (
    <FormControl isInvalid={hasError}>
      <FormLabel data-testid={label} fontSize="16px" mb={0} fontWeight="500" role="label" aria-labelledby={name} color="#27272A">
        <HStack alignItems="flex-end">
          <span>{label}</span>
        </HStack>
      </FormLabel>

      <InputGroup size='md'>
        <Field
          data-lpignore={false}
          data-testid={label + '_input'}
          as={Input}
          maxLength={maxLength}
          name={name}
          isReadOnly={isReadOnly}
          color="darkText"
          focusBorderColor="muted.200"
        />
      </InputGroup>
      <Flex justify="space-between" align="center">
        {hasError && (
          <FormErrorMessage data-testid={label + '_error'} fontSize='14px' mt='4px'>
            {meta.error}
          </FormErrorMessage>
        )}
      </Flex>
    </FormControl>
  );
};

InputLabelField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  maxLength: PropTypes.number,
  isReadOnly: PropTypes.bool,
};
